export const ARTICLE = 'article';
export const QUESTION = 'question';
export const CHOICES = 'choices';
export const FEEDBACK = 'feedback';
export const FEEDBACK_CORRECT = 'feedback-correct';
export const FEEDBACK_INCORRECT = 'feedback-incorrect';
